export default {
    getUid () {
        return `_${Math.random().toString(36).
            substr(2, 9)}`;
    },
    deepCopy (o) {
        return JSON.parse(JSON.stringify(o));
    },

    areEqual (lhs, rhs) {

        // same object
        if (lhs === rhs) {
            return true;
        }

        // equal objects
        return JSON.stringify(lhs) === JSON.stringify(rhs);
    }
};
